export { ar } from './bs-moment/i18n/ar';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
